import React from 'react';
import { useNavigate } from 'react-router-dom';

interface PaidPassRequiredModalProps {
  open: boolean;
  onClose: () => void;
}

/**
 * 프리 이용권에서 유료 기능을 눌렀을 때 안내.
 * [닫기] [이용권 구매하기]
 */
const PaidPassRequiredModal: React.FC<PaidPassRequiredModalProps> = ({ open, onClose }) => {
  const navigate = useNavigate();
  if (!open) return null;

  return (
    <div
      className="cp-modal-backdrop cp-paid-pass-required-backdrop"
      role="presentation"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div
        className="cp-modal cp-paid-pass-required-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="cp-paid-pass-required-title"
        onMouseDown={(e) => e.stopPropagation()}
      >
        <h3 id="cp-paid-pass-required-title" className="cp-paid-pass-required-title">
          이용권 안내
        </h3>
        <p className="cp-paid-pass-required-desc">
          이용권을 구매하면 해당 서비스 이용이 가능합니다.
        </p>
        <div className="cp-modal-footer cp-paid-pass-required-actions">
          <button type="button" className="cp-btn-secondary" onClick={onClose}>
            닫기
          </button>
          <button
            type="button"
            className="cp-btn-primary"
            onClick={() => {
              onClose();
              navigate('/subscription');
            }}
          >
            이용권 구매하기
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaidPassRequiredModal;
